import { render, staticRenderFns } from "./plabel.vue?vue&type=template&id=b809c77c&scoped=true&"
import script from "./plabel.vue?vue&type=script&lang=js&"
export * from "./plabel.vue?vue&type=script&lang=js&"
import style0 from "./plabel.vue?vue&type=style&index=0&id=b809c77c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b809c77c",
  null
  
)

export default component.exports